import React, { useState } from 'react';
import dealerDestructure from 'helpers/dealer-destructure';
import ProductOffer from 'components/product/product-offer/product-offer';
import OfferInterface from 'interfaces/offer.interface';
import flectionNumeral from 'helpers/number';
import './product-offer-wrapper.scss';

const ProductOfferWrapper: React.FC<{ offer: OfferInterface; }> = ({ offer }) => {
    const { highlighted, freeDelivery, inPost, delivery24h, rates, fastPayment, promoText } = dealerDestructure(offer.dealer);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const onToggleOpen = (): void => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="offer-wrapper">
            <ProductOffer
                id={offer.id}
                shopUrl={offer.url}
                highlighted={Boolean(highlighted)}
                dealer={{
                    id: offer.dealer.id,
                    name: offer.dealer.name,
                    logo: offer.dealer.logo,
                    authorized: offer.dealer.authorized,
                    badge: offer.dealer.opinions?.badges.badge
                }}
                badges={{
                    fastPayment: Boolean(fastPayment),
                    isQuality: offer.dealer.opinions?.badges.qsign,
                    isOpineoQuality: offer.dealer.opinions?.badges.credibilityVerification,
                    inPost: Boolean(inPost),
                    freeDelivery: Boolean(freeDelivery),
                    delivery24: Boolean(delivery24h),
                    promoText: promoText?.content
                }}
                price={offer.price}
                image={offer.photo.src}
                title={offer.description}
                rates={Boolean(rates)}
                opinions={offer.dealer.opinions}
                variantsCount={offer.variants ? offer.variants.length : 0}
                isOpen={isOpen}
                toggleOpen={onToggleOpen}
                starsSize={'xs'}
                availability={offer.availability}
            />
            { offer.variants && offer.variants.length > 0 && (
                <div className={`offer-wrapper-variants-count ${isOpen ? 'active' : ''}`}>
                    {flectionNumeral(offer.variants.length, ['wariant', 'warianty', 'wariantów'])}
                </div>
            )}
            <div className={`offer-wrapper-variants ${isOpen ? 'offer-wrapper-variants--expanded' : ''}`}>
                {offer.variants && offer.variants.length > 0 && offer.variants.map(variant => (
                    <ProductOffer
                        id={offer.id}
                        shopUrl={variant.url}
                        key={variant.id}
                        price={variant.price}
                        rates={Boolean(rates)}
                        title={variant.description}
                        image={variant.photo.src}
                        dealer={{
                            id: offer.dealer.id,
                            logo: offer.dealer.logo,
                            name: variant.dealer.name,
                            authorized: offer.dealer.authorized
                        }}
                        badges={{
                            fastPayment: Boolean(fastPayment),
                            isQuality: variant.dealer.opinions?.badges.qsign,
                            isOpineoQuality: offer.dealer.opinions?.badges.credibilityVerification,
                            inPost: Boolean(inPost),
                            freeDelivery: Boolean(freeDelivery),
                            delivery24: Boolean(delivery24h)
                        }}
                        opinions={variant.dealer.opinions}
                        toggleOpen={onToggleOpen}
                        starsSize={'xs'}
                        availability={offer.availability}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProductOfferWrapper;
